import Navbar from "react-bootstrap/Navbar";
import {Dropdown, Nav} from "react-bootstrap";
import React, {useContext} from "react";
import {BackendContext} from "../context/Backend";
import {useNavigate, useRouteLoaderData} from "react-router";
import styles from "./navigation.module.css";
import {useSubmit} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Power} from "react-bootstrap-icons";

export const BottomNav = (props) => {
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();

    const handleLocale = (e) => {
        i18n.changeLanguage(e.currentTarget.getAttribute("data-locale"))
    }

    const legalLinksMap = new Map([
        ['terms', {
            label: t('legalInfos.termsOfUse'),
            target: '_blank',
            url: {
                en: 'https://www.websignatureoffice.com/en/terms-of-use/',
                de: 'https://www.websignatureoffice.com/agb/',
                es: 'https://www.websignatureoffice.com/es/terminos-y-condiciones/'
            }
        }],
        ['imprint', {
            label: t('legalInfos.imprint'),
            target: '_blank',
            url: {
                en: 'https://www.websignatureoffice.com/en/legal-notice/',
                de: 'https://www.websignatureoffice.com/impressum/',
                es: 'https://www.websignatureoffice.com/es/aviso-legal/'
            }
        }],
        ['dataProtection', {
            label: t('legalInfos.dataProtection'),
            target: '_blank',
            url: {
                en: 'https://www.websignatureoffice.com/en/data-protection/',
                de: 'https://www.websignatureoffice.com/datenschutz/',
                es: 'https://www.websignatureoffice.com/es/proteccion-de-datos/'
            }
        }],
    ]);

    return (
        <Navbar className={['border-top', 'p-0', 'bg-primary', 'justify-content-center', styles.bottomNav].join(' ')}>
            <Nav as="ul">
                {
                    Array.from(legalLinksMap.entries()).map(([key, {label, target, url}]) => (
                        <Nav.Item as="li" key={key}>
                            <Nav.Link href={url[i18n.resolvedLanguage || 'en']} target={target}>{label}</Nav.Link>
                        </Nav.Item>
                    ))
                }
            </Nav>
        </Navbar>);
}